<template>
	<div class="fi-row">
		<it-link :to="'createComment.do?id='+fi.id" class="fi-rowIcon"><sym-icon name="message"></sym-icon></it-link>
		<div class="fi-row-message">
			<span v-if="fi.srcType === SrcType.TASK">{{ env.msg('forceInfo.commentTask') }}:</span>
			<span v-else-if="fi.srcType === SrcType.BUSCASE">{{ env.msg('forceInfo.commentBC') }}:</span>
			<object-link :src-id="fi.srcId" :src-type="fi.srcType">{{ fi.srcName }}</object-link>
			<it-link v-if="isMe" :to="'createForceComment.do?id='+fi.id" class="fbutton">{{ env.msg('forceInfo.complete') }}</it-link>
			<fi-date :value="fi.entered"></fi-date>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import type {ForceInfo} from "@t/processes/ForceInfo.ts";
import {SrcType} from "@t/meta/SourceType.ts";
import {injectEnv} from "@fd/Environment.ts";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import FiDate from "@/processes/FiDate.vue";

const props = defineProps<{
	fi:ForceInfo
}>();
const env = injectEnv();
const isMe = computed<boolean>(() => {
	return props.fi.responsible === env.user.login;
});
</script>

<style>

</style>